import * as React from 'react';
import {
    Button,
    createStyles,
    Grid,
    TextField,
    Theme,
    withStyles
} from '@material-ui/core';
import {API} from "aws-amplify";
import {Alert} from "@material-ui/lab";
import JsonRenderComponent from "../../../../../../utils/JsonRenderComponent";
import { LoadingSpinner } from "../../../../../../utils/LoadingSpinner";
import CreateAndSendCarePartnerInvitationResult from "./CreateAndSendCarePartnerInvitationResult";

const styles = ({spacing}: Theme) => createStyles({
    buttonWrapper: {
        backgroundColor: '#00cc00',
        marginTop: spacing(1),
    }
});

interface ICreateAndSendCarePartnerInvitationState {
    actingAgentMemberId: string,
    caregiverPersonId: string,
    errorText: string,
    errorMessage: any,
    formSubmitted: boolean,
    inviteeCountryCode: string,
    inviteeEmail: string,
    inviteeMobileNumber: string,
    inviteeName: string,
    message: string,
    open: boolean,
    response: any
    resultSuccessful: boolean,
    showDropDowns: boolean,
    showLoadingSpinner: boolean;
}

class CreateAndSendCarePartnerInvitationSection extends React.Component<any, ICreateAndSendCarePartnerInvitationState> {
    constructor(props: any) {
        super(props);

        this.state = {
            actingAgentMemberId: '',
            caregiverPersonId: '',
            errorMessage: '',
            errorText: '',
            formSubmitted: false,
            inviteeCountryCode: '+1',
            inviteeEmail: '',
            inviteeMobileNumber: '',
            inviteeName: '',
            message: '',
            open: false,
            response: '',
            resultSuccessful: false,
            showDropDowns: false,
            showLoadingSpinner: false
        };

        this.handleActingAgentMemberId = this.handleActingAgentMemberId.bind(this);
        this.handleCaregiverPersonId = this.handleCaregiverPersonId.bind(this);
        this.handleInviteeCountryCode = this.handleInviteeCountryCode.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleInviteeEmail = this.handleInviteeEmail.bind(this);
        this.handleInviteeMobileNumber = this.handleInviteeMobileNumber.bind(this);
        this.handleInviteeName = this.handleInviteeName.bind(this);
    }

    public render() {
        return (
            <Grid item xs={12}>
                <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                    spacing={3}
                >
                    {this.state.showLoadingSpinner && <LoadingSpinner/>}

                    <Grid item xs>
                        <TextField
                            style={{width: 300}}
                            label="Inviter Person Id (Required)"
                            helperText="Care receiver, or minor's personId when an acting agent is set"
                            variant="outlined"
                            value={this.state.caregiverPersonId}
                            onChange={this.handleCaregiverPersonId}
                        />
                    </Grid>
                    <Grid item xs>
                        <TextField
                            style={{width: 300}}
                            label="Acting Agent Person Id (Optional)"
                            helperText="Primary caregiver doing the inviting; leave blank for adult flow"
                            variant="outlined"
                            value={this.state.actingAgentMemberId}
                            onChange={this.handleActingAgentMemberId}
                        />
                    </Grid>
                    <Grid item xs>
                        <TextField
                            style={{width: 300}}
                            label="Invitee Name (Required)"
                            helperText="Caregiver being invited"
                            variant="outlined"
                            value={this.state.inviteeName}
                            onChange={this.handleInviteeName}
                        />
                    </Grid>
                    <Grid item xs>
                        <TextField
                            style={{width: 300}}
                            label="Invitee Email (Required)"
                            variant="outlined"
                            value={this.state.inviteeEmail}
                            onChange={this.handleInviteeEmail}
                        />
                    </Grid>
                    <Grid item xs>
                        <TextField
                            style={{width: 300}}
                            label="Invitee Country Code (Required)"
                            variant="outlined"
                            value={this.state.inviteeCountryCode}
                            onChange={this.handleInviteeCountryCode}
                        />
                    </Grid>
                    <Grid item xs>
                        <TextField
                            style={{width: 300}}
                            label="Invitee Mobile Number  (Required) #"
                            variant="outlined"
                            value={this.state.inviteeMobileNumber}
                            onChange={this.handleInviteeMobileNumber}
                        />
                    </Grid>

                    <Grid item xs>
                        <Button variant="outlined" color="default" onClick={this.handleSubmit}>
                            Submit
                        </Button>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    {this.state.formSubmitted && <LoadingSpinner/>}
                    {this.state.resultSuccessful &&
                        <CreateAndSendCarePartnerInvitationResult resultSuccessful={this.state.resultSuccessful} response={this.state.response}/>}
                </Grid>

                { this.state.errorMessage &&
                    <div>
                        <br/>
                        <h4>Encountered an Error</h4>
                        <p style={{
                            border: '3px solid lightgray',
                            padding: '5px',
                            whiteSpace: "pre-wrap",
                            wordBreak: "normal",
                            wordWrap: "break-word"
                        }}>
                            <Alert variant="filled" severity="info">
                                { this.state.errorMessage }
                            </Alert>
                        </p>
                    </div>
                }

                { this.state.response &&
                    <div>
                        <br/>
                        <h4>Create And Send Care Partner Invitation Response</h4>
                        <p style={{
                            border: '3px solid lightgray',
                            padding: '5px',
                            whiteSpace: "pre-wrap",
                            wordBreak: "normal",
                            wordWrap: "break-word"
                        }}>
                            <JsonRenderComponent jsonObject={ this.state.response } printHtml={ false }/>
                        </p>
                    </div>
                }
            </Grid>
        );
    }

    public handleClose() {
        this.setState({open: false})
    }

    public handleActingAgentMemberId(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({actingAgentMemberId: event.target.value})
    }

    public handleCaregiverPersonId(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({caregiverPersonId: event.target.value})
    }

    public handleInviteeName(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({inviteeName: event.target.value})
    }

    public handleInviteeEmail(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({inviteeEmail: event.target.value})
    }

    public handleInviteeCountryCode(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({inviteeCountryCode: event.target.value})
    }

    public handleInviteeMobileNumber(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({inviteeMobileNumber: event.target.value})
    }

    private handleSubmit() {
        // Set initial state for form submission and reset previous messages
        this.setState({
            errorMessage: null,
            formSubmitted: true,
            resultSuccessful: false,
        });

        const apiName = 'ApaqPortalAPI';
        const path = '/pharmacy-customer/update/create-and-send-care-partner-invitation';
        const config = {
            body: {
                caregiverPersonId: this.state.caregiverPersonId,
                inviteeCountryCode: this.state.inviteeCountryCode,
                inviteeEmail: this.state.inviteeEmail,
                inviteeMobileNumber: this.state.inviteeMobileNumber,
                inviteeName: this.state.inviteeName,
                ...(this.state.actingAgentMemberId ? {actingAgentMemberId: this.state.actingAgentMemberId} : {}),
            },
            headers: {}
        };

        API.post(apiName, path, config)
            .then((response: any) => {
                console.log(response);
                this.setState({
                    formSubmitted: false,
                    response
                });
            })
            .catch((error) => {
                console.error(error);
                alert(error);
                this.setState({
                    errorMessage: error.response?.errorMessage,
                    formSubmitted: false
                });
            });
    }
}

export default withStyles(styles)(CreateAndSendCarePartnerInvitationSection);
